module.exports = __webpack_public_path__ + "static/media/tip—banner@2x.a790f0b8.png";